import React, { useEffect, useState, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Switch from 'react-switch';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { Card, CardText, CardTitle, Input, CardBody, Row, Col, TabContent, TabPane } from 'reactstrap';
// libs
// components
import Loader from '../common/Loader';
// Managed product components
import AWSFilters from './section/AWSFilters';
import ProductPriority from './section/ProductPriority';
// import ProductPriorityCoFilters from './section/ProductPriorityCoFilters';
import ProductActions from './section/ProductActions';
// constants
// import vendors from '../../constants/vendors';
import servicenow from '../../constants/servicenow';
// services
import BZAPIService from '../../services/BZAPIService';
// context
import { VendorsContext } from '../../context/VendorsContext';

export default function ManagedProductForm({ vendorBugCategoryOptions, vendorBugTypeOptions }) {
  const { vendorId, managedProductId: productId } = useParams();
  const navigate = useNavigate();
  // Set default form values
  const snPriorityOptions = servicenow.SN_PRIORITY_OPTIONS;

  // const [vendorLabel, setVendorLabel] = useState(false);
  // saving states
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [showAdded, setShowAdded] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [vendorResolutions, setVendorResolutions] = useState([]);

  // Managed Product
  const [loadedManagedProduct, setLoadedManagedProduct] = useState(null);
  const [snProductId, setSnProductId] = useState(null);
  const [vendorStatuses, setVendorStatuses] = useState([]);
  const [vendorBugTypes, setVendorBugTypes] = useState([]);
  const [vendorBugCategories, setVendorBugCategories] = useState([]);
  const [vendorBugServices, setVendorBugServices] = useState([]);
  const [vendorProductBugCategories, setVendorProductBugCategories] = useState([]);
  // const [vendorRiskCategories, setVendorRiskCategories] = useState([]);

  const [loader, setLoader] = useState(false);

  // Data sources

  const [priorityMaps, setPriorityMaps] = useState([]);
  const [keywords, setKeywords] = useState([]);
  const [includedComponents, setIncludedComponents] = useState([]);
  const [excludedComponents, setExcludedComponents] = useState([]);
  const [searchFields, setSearchFields] = useState([]);
  const [vendorEventScopes, setVendorEventScopes] = useState([]);

  const [vendorImpactedRegions, setVendorImpactedRegions] = useState([]);
  const [vendorMitigationTypes, setVendorMitigationTypes] = useState([]);
  const [vendorRiskCategories, setVendorRiskCategories] = useState([]);

  const [activeTab, setActiveTab] = useState('1');

  const [query, setQuery] = useState('');
  const [offset, setOffset] = useState('0');
  const [limit, setLimit] = useState('2500');

  // eslint-disable-next-line
  const [vendors, setVendors] = useContext(VendorsContext);
  const [vendor, setVendor] = useState();
  const [enableChatGptPriority, setEnableChatGptPriority] = useState(false);

  async function onLoad(vendor) {
    setActiveTab('1');
    setLoader(true);
    // console.log('vendor', vendor);
    try {
      try {
        const aiSettingsRes = await BZAPIService.getVendorAiSetting(vendorId);
        const isAiEnabled = !!(aiSettingsRes?.vendor?.aiEnabled && aiSettingsRes?.globalAi?.aiEnabled);
        setEnableChatGptPriority(isAiEnabled);
      } catch (e) {
        // AI settings are optional for non-AI vendors; fall back to legacy mode
        setEnableChatGptPriority(false);
      }
      const managedProduct = await BZAPIService.getManagedProduct(productId);

      let components =
        vendorId === 'rh' || vendorId === 'cisco' || vendorId === 'mongodb'
          ? await BZAPIService.getComponents(vendorId, query, offset, limit)
          : [];
      const includedComponents = components.results || [];
      setIncludedComponents(includedComponents);

      // Validate config

      const priorityMaps = managedProduct?.vendorPriorities?.map(priority => {
        const result = {
          vendorPriority: vendor?.vendorData?.priorities?.find(e => e.value === priority.value),
          snPriority: snPriorityOptions?.find(e => e.value === priority.snPriority)
        };
        console.log('result', result);
        return result;
      });
      // console.log('priorityMaps', priorityMaps);
      setPriorityMaps(priorityMaps);

      // Set Managed product if exists

      if (managedProduct.vendorData && managedProduct.vendorData.vendorBugResolutions) {
        setVendorResolutions(managedProduct.vendorData.vendorBugResolutions);
      }

      managedProduct.vendorData && managedProduct.vendorData.vendorImpactedRegions
        ? setVendorImpactedRegions(managedProduct.vendorData.vendorImpactedRegions)
        : setVendorImpactedRegions([]);

      managedProduct.vendorData && managedProduct.vendorData.vendorBugTypes
        ? setVendorBugTypes(managedProduct.vendorData.vendorBugTypes)
        : setVendorBugTypes([]);

      managedProduct.vendorData && managedProduct.vendorData.vendorBugServices
        ? setVendorBugServices(managedProduct.vendorData.vendorBugServices)
        : setVendorBugServices([]);

      managedProduct.vendorData && managedProduct.vendorData.vendorBugCategories
        ? setVendorBugCategories(managedProduct.vendorData.vendorBugCategories)
        : setVendorBugCategories([]);
      managedProduct.vendorData && managedProduct.vendorData.vendorBugModules
        ? setVendorProductBugCategories(managedProduct.vendorData.vendorBugModules)
        : setVendorProductBugCategories([]);
      excludedComponents.length
        ? setExcludedComponents(excludedComponents)
        : managedProduct.vendorData && managedProduct.vendorData.excludedBugComponents
        ? setExcludedComponents(managedProduct.vendorData.excludedBugComponents)
        : setExcludedComponents([]);

      managedProduct.vendorData && managedProduct.vendorData.excludedKws
        ? setKeywords(managedProduct.vendorData.excludedKws)
        : setKeywords([]);

      managedProduct.vendorData && managedProduct.vendorData.searchFields
        ? setSearchFields(managedProduct.vendorData.searchFields)
        : setSearchFields([]);

      managedProduct.vendorData && managedProduct.vendorData.vendorEventScopes
        ? setVendorEventScopes(managedProduct.vendorData.vendorEventScopes)
        : setVendorEventScopes([]);

      managedProduct.vendorData && managedProduct.vendorData.vendorRiskCategories
        ? setVendorRiskCategories(managedProduct.vendorData.vendorRiskCategories)
        : setVendorRiskCategories([]);

      managedProduct?.vendorData?.vendorMitigationTypes
        ? setVendorMitigationTypes(managedProduct.vendorData.vendorMitigationTypes)
        : setVendorMitigationTypes([]);

      setSnProductId(managedProduct.snProductId);
      setIsDisabled(!!managedProduct.isDisabled);
      setLoadedManagedProduct(managedProduct);
      setVendorStatuses(managedProduct.vendorStatuses);
      // map option values to db values
      // console.log('vendorPriorityOptions', vendorPriorityOptions);

      setIsLoading(false);
      setLoader(false);
    } catch (e) {
      console.log(e);
      setIsLoading(false);
      setLoader(false);
    }
  }

  useEffect(() => {
    if (vendors?.length) {
      const vendor = vendors?.filter(v => v.id === vendorId);
      setVendor(vendor[0]);
      onLoad(vendor[0]);
    }
    // eslint-disable-next-line
  }, [productId, vendors, vendorId]);

  function updateManagedProduct() {
    const vendorPriorities = priorityMaps?.map(mapping => {
      return {
        value: mapping.vendorPriority.value,
        label: mapping.vendorPriority.value,
        snPriority: mapping.snPriority.value
      };
    });
    let managedProduct = {
      ...loadedManagedProduct,
      vendorStatuses,
      vendorPriorities,
      vendorData: {
        ...loadedManagedProduct.vendorData,
        vendorBugResolutions: vendorResolutions,
        vendorBugCategories,
        vendorBugServices,
        vendorBugTypes,
        excludedBugComponents: excludedComponents,
        excludedKws: keywords,
        searchFields: searchFields,
        vendorBugModules: vendorProductBugCategories,
        // vendorEventLevels,
        vendorEventScopes,
        vendorImpactedRegions,
        vendorRiskCategories,
        vendorMitigationTypes
        // supportCasesCount: isCasesOn ? supportCasesCount : 0
        // bugRiskScore: bugRisk
      },
      vendorId,
      isDisabled
    };

    console.log('managedProduct', managedProduct);

    return BZAPIService.createOrUpdateManagedProduct(managedProduct);
  }

  async function saveProduct() {
    setIsSubmitted(true);
    setIsLoading(true);
    // basic validation

    // Vendor status
    if (vendor?.vendorData?.statuses?.length && !vendorStatuses.length) {
      console.log('Missing vendor status');
      setIsLoading(false);
      return false;
    }

    // Vendor status
    if (vendorBugCategoryOptions.length && !vendorBugCategories.length) {
      console.log('Missing vendor categories');
      setIsLoading(false);
      return false;
    }
    // Azure validation
    if (vendor?.vendorData?.eventScopes?.length && !vendorEventScopes.length) {
      console.log('Missing event scopes');
      setIsLoading(false);
      return false;
    }
    if (vendor?.vendorData?.vendorImpactedRegions?.length && !vendorImpactedRegions.length) {
      console.log('Missing regions');
      setIsLoading(false);
      return false;
    }

    // Fortinet categories validation
    if (vendor?.vendorData?.vendorBugServices?.length && !vendorBugServices.length) {
      console.log('Missing Fortinet modules');
      setIsLoading(false);
      return false;
    }

    // F5 categories validation
    const bugCategoryOptions =
      vendor?.vendorData?.vendorProductBugCategories && vendor?.vendorData?.vendorProductBugCategories['BIG-IP']
        ? vendor?.vendorData?.vendorProductBugCategories['BIG-IP']
        : [];
    if (bugCategoryOptions?.length && !vendorProductBugCategories.length) {
      console.log('Missing F5 modules');
      setIsLoading(false);
      return false;
    }

    // Vendor Priority Mapping
    let validPriorities = true;
    priorityMaps.map(item => {
      if (!item.vendorPriority || !item.snPriority) validPriorities = false;
      return item;
    });
    if (!validPriorities) {
      console.log('Invalid priorities');
      setIsLoading(false);
      return false;
    }

    try {
      await updateManagedProduct();
      setIsLoading(false);
      toast.success('Managed product saved!');

      return true;
    } catch (e) {
      console.error(e);
      setIsLoading(false);
      toast.error('Failed saving product.');

      return false;
    }
  }
  async function handleSave() {
    const result = await saveProduct();
    if (result) navigate(`/vendors/${vendorId}/products`);

    // Go back to listing
  }
  async function handleSaveAndAdd() {
    const result = await saveProduct();
    if (result) {
      setIsSubmitted(false);
      setSnProductId(null);
      setShowAdded(true);
    }
    // Clear Operating system / Product Link
  }

  function deleteManagedProduct() {
    return BZAPIService.deleteManagedProduct(productId);
  }

  async function handleToggleEnable() {
    setIsDisabled(!isDisabled);
  }
  async function handleDelete(event) {
    event.preventDefault();

    const confirmed = window.confirm('Are you sure you want to delete this managedProduct?');

    if (!confirmed) {
      return;
    }

    try {
      await deleteManagedProduct();
      navigate(`/managedProducts/${vendorId}`);
    } catch (e) {
      console.log(e);
      toast.error('Failed to delete product');
    }
  }

  const handleStatusVariableChange = (e, variable, option) => {
    const num = e.target.value;
    console.log('num', num);

    const options = [...vendorStatuses];
    const variables = [...option.variables];

    // const statuses = vendorStatuses.map(item => {
    //   return item.label === option.label ? update : item;
    // });

    const optionIndex = vendorStatuses.findIndex(item => {
      return item.label === option.label;
    });

    const varsIndex = option.variables.findIndex(item => {
      return item.label === variable.label;
    });

    variables[varsIndex] = { ...variables[varsIndex], value: num };
    options[optionIndex] = { ...options[optionIndex], variables };

    setVendorStatuses(options);
    console.log('options', options);
  };

  const handleSwitchToggle = (e, option) => {
    // const check = e.target.checked;
    console.log(e);

    const options = [...vendorStatuses];
    const optionIndex = vendorStatuses.findIndex(item => {
      return item.label === option.label;
    });

    options[optionIndex] = { ...options[optionIndex], active: e === true ? 1 : 0 };

    setVendorStatuses(options);
  };

  if (isLoading && !isSubmitted) return <Loader text="Loading product..." />;

  return (
    <>
      <TabContent>
        <div style={{ minWidth: '100%' }}>
          <TabPane tabId="1">
            {activeTab === '1' && (
              <form noValidate>
                {!!loadedManagedProduct && (
                  <Card className="mb-3">
                    <CardBody>
                      <Row className="justify-content-between align-items-center">
                        <Col md>
                          <h5 className="mb-2 mb-md-0">{loadedManagedProduct?.name}</h5>
                        </Col>
                        <Col xs="auto">
                          <h5>
                            <span style={{ position: 'relative', top: '3px' }}>
                              <Switch
                                onChange={handleToggleEnable}
                                checked={!isDisabled}
                                height={20}
                                onColor="#253746"
                              />{' '}
                            </span>

                            <span>{isDisabled ? 'Disabled' : 'Enabled'}</span>
                          </h5>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                )}
                {vendorStatuses?.length && vendorStatuses[0]?.hasOwnProperty('variables') ? (
                  <Card bg={'light'} text={'dark'} style={{}} className="mb-4">
                    <CardBody>
                      <CardTitle className="">Select Bug Statuses to Monitor</CardTitle>
                      <CardText>Select multiple entries if necessary</CardText>
                      <Row>
                        {vendorStatuses.map(option => {
                          return (
                            <Col lg="6" key={option.label + 'option'}>
                              <Card className="mt-2">
                                <CardBody>
                                  <Row>
                                    <Col xs={8}>
                                      <CardTitle>{option.label}</CardTitle>
                                    </Col>
                                    <Col xs={4} className="text-right">
                                      <Switch
                                        id={option.label + '-switch'}
                                        onChange={e => handleSwitchToggle(e, option)}
                                        checked={option.active === 1 ? true : false}
                                        uncheckedIcon={false}
                                        onColor="#253746"
                                        height={14}
                                        width={28}
                                      />
                                    </Col>
                                  </Row>
                                  {option.variables.map(variable => {
                                    return (
                                      <Row
                                        key={variable.label + option.label + 'variableKey'}
                                        id={variable.label + option.label + 'variableId'}
                                        className="mt-2"
                                      >
                                        <Col>
                                          <strong>{variable.label}</strong>
                                        </Col>
                                        <Col>
                                          <Input
                                            placeholder="0"
                                            type="number"
                                            key={variable.label + 'input'}
                                            autoFocus="autoFocus"
                                            value={variable.value}
                                            onChange={e => handleStatusVariableChange(e, variable, option)}
                                            disabled={option.active === 1 ? false : true}
                                            min="0"
                                          />
                                        </Col>
                                      </Row>
                                    );
                                  })}
                                </CardBody>
                              </Card>
                            </Col>
                          );
                        })}
                      </Row>
                    </CardBody>
                  </Card>
                ) : (
                  <></>
                )}

                {vendorId === 'aws' || vendorId === 'azure' ? (
                  <AWSFilters
                    vendorEventScopeOptions={vendor?.vendorData?.eventScopes}
                    setVendorEventScopes={setVendorEventScopes}
                    isSubmitted={isSubmitted}
                    vendorEventScopes={vendorEventScopes}
                    vendorLabel={vendor?.name}
                  />
                ) : (
                  ''
                )}
                {/* PRIORITY */}
                <ProductPriority
                  title="Bug Configuration"
                  vendorId={vendorId}
                  vendorPriorityOptions={vendor?.vendorData?.priorities}
                  enableChatGptPriority={enableChatGptPriority}
                  vendorResolutionOptions={vendor?.vendorData?.vendorBugResolutions}
                  vendorStatusOptions={vendor?.vendorData?.statuses}
                  setVendorStatuses={setVendorStatuses}
                  vendorStatuses={vendorStatuses}
                  setVendorBugTypes={setVendorBugTypes}
                  setVendorBugCategories={setVendorBugCategories}
                  vendorBugTypeOptions={vendorBugTypeOptions}
                  vendorBugCategoryOptions={vendorBugCategoryOptions}
                  vendorBugTypes={vendorBugTypes}
                  vendorBugCategories={vendorBugCategories}
                  setVendorResolutions={setVendorResolutions}
                  vendorResolutions={vendorResolutions}
                  snProductId={snProductId}
                  isSubmitted={isSubmitted}
                  priorityMaps={priorityMaps}
                  setPriorityMaps={setPriorityMaps}
                  snPriorityOptions={snPriorityOptions}
                  keywords={keywords}
                  setKeywords={setKeywords}
                  includedComponents={includedComponents}
                  setIncludedComponents={setIncludedComponents}
                  excludedComponents={excludedComponents}
                  setExcludedComponents={setExcludedComponents}
                  searchFields={searchFields}
                  setSearchFields={setSearchFields}
                  loader={loader}
                  setLoader={setLoader}
                  setQuery={setQuery}
                  query={query}
                  offset={offset}
                  limit={limit}
                  setOffset={setOffset}
                  setLimit={setLimit}
                  setVendorBugServices={setVendorBugServices}
                  vendorBugServices={vendorBugServices}
                  vendorBugServiceOptions={vendor?.vendorData?.vendorBugServices}
                  vendorProductBugCategories={vendorProductBugCategories}
                  vendorProductBugCategoryOptions={
                    vendor?.vendorData?.vendorProductBugCategories &&
                    vendor?.vendorData?.vendorProductBugCategories['BIG-IP']
                      ? vendor?.vendorData?.vendorProductBugCategories['BIG-IP']
                      : []
                  }
                  setVendorProductBugCategories={setVendorProductBugCategories}
                  vendorImpactedRegions={vendorImpactedRegions}
                  setVendorImpactedRegions={setVendorImpactedRegions}
                  vendorImpactedRegionOptions={vendor?.vendorData?.vendorImpactedRegions}
                  vendorRiskCategoryOptions={vendor?.vendorData?.vendorRiskCategories}
                  vendorRiskCategories={vendorRiskCategories}
                  setVendorRiskCategories={setVendorRiskCategories}
                  vendorMitigationTypes={vendorMitigationTypes}
                  setVendorMitigationTypes={setVendorMitigationTypes}
                  vendorMitigationTypeOptions={vendor?.vendorData?.vendorMitigationTypes}
                />

                {/* Form action */}
                <ProductActions
                  isLoading={isLoading}
                  handleDelete={handleDelete}
                  handleSave={handleSave}
                  handleSaveAndAdd={handleSaveAndAdd}
                  setShowAdded={setShowAdded}
                  showAdded={showAdded}
                  vendorId={vendorId}
                  productId={productId}
                />
              </form>
            )}
          </TabPane>
        </div>
      </TabContent>
    </>
  );
}

ManagedProductForm.propTypes = {
  vendorBugTypeOptions: PropTypes.array,
  vendorBugCategoryOptions: PropTypes.array
};
